import { Route } from 'react-router-dom'

import OfflinePackages from '../../components/PackageRoom/OfflinePackages'
import PackageRoomRoute from '../../components/PackageRoom/PackageRoomRoute'

export const packageRoomRoutesConfig = () => (
  <>
    <Route path="package-room" element={<PackageRoomRoute />} />
    <Route path="package-room/offline" element={<OfflinePackages />} />
  </>
)
